import React from 'react';
const modules = [{
  num: '1',
  title: 'Functional Foundations™',
  description: 'Professionelle Stundenstruktur-Frameworks, Bewegungsmuster-Grundlagen, Trainingsaufbau-Leitfäden, Session-Flow-Vorlagen, Coaching-Prinzipien und Sicherheitschecklisten – bereit, jede Einheit auf professionelles Niveau zu heben.'
}, {
  num: '2',
  title: 'Movement Library™',
  description: 'Eine umfangreiche kategorisierte Übungsbibliothek für Squat, Hinge, Push, Pull, Lunge, Carry, Core, Rotation, Power und Conditioning – mit Progressionen, Regressionen, Coaching Cues und Equipment-Optionen.'
}, {
  num: '3',
  title: 'Class Builder System™',
  description: 'Praktische Frameworks und Vorlagen für 30-, 45- und 60-Minuten-Klassen, Klein- und Großgruppen, EMOM, AMRAP, Circuits, HIIT, Kraft- und Conditioning-Einheiten – jeden Kurs in Minuten aufbauen.'
}, {
  num: '4',
  title: 'Ready-to-Use Workouts™',
  description: 'Eine große Sammlung vollständiger, sofort einsetzbarer Functional Workouts für Anfänger, Fortgeschrittene und Experten – mit Zielen für Gewichtsverlust, athletische Leistung, Fitness, Kraft, Conditioning, Core und Mobilität.'
}, {
  num: '5',
  title: 'Progression Programs™',
  description: 'Vollständige Mehrwochen-Trainingsprogramme mit 4-, 6- und 8-Wochen-Plänen, Kraft- und Conditioning-Progressionen, Fortschritts-Tracking, wöchentlichen Zielen und Programmierungskalendern.'
}, {
  num: '6',
  title: 'Coaching Tools™',
  description: 'Professionelle Praxiswerkzeuge: Kursplanungsvorlagen, Anwesenheitslisten, Kundenverfolgung, Assessmentformulare, Zielblätter, Fortschrittschecklisten, Monatsplaner und Workout-Logs.'
}];
export function TomiSection() {
  return <section className="py-10 px-4 bg-brand-cream" data-id="element-162">
      <div className="max-w-4xl mx-auto" data-id="element-163">
        <div className="text-center mb-5" data-id="element-164">
          <p className="text-sm font-bold text-brand-gold uppercase tracking-wide mb-2" data-id="element-165">
            Die Lösung, die Sie gesucht haben
          </p>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-brand-graphite mb-2" data-id="element-166">
            EIN VOLLSTÄNDIGES 6-IN-1-PLANUNGSSYSTEM
          </h2>
          <p className="text-base text-brand-graphite/70 mb-3" data-id="element-167">
            6 professionelle Module in einem vollständigen System für Functional
            Trainer
          </p>
          <div className="inline-block bg-brand-petrol/10 border-2 border-brand-petrol px-4 py-1.5 rounded-lg mb-3" data-id="element-168">
            <p className="font-bold text-brand-petrol text-lg" data-id="element-169">
              🏋️ FUNCTIONAL TRAINER SYSTEM™
            </p>
          </div>
          <p className="text-base text-brand-graphite/80 max-w-3xl mx-auto" data-id="element-170">
            Weit mehr als eine Sammlung von Trainingsvorlagen und Übungslisten.
            Ein vollständiges professionelles Planungssystem, das Trainer und
            Studio-Inhaber dabei unterstützt, Kurse schneller aufzubauen,
            Prozesse effizienter zu organisieren, die Programmierung zu
            vereinfachen und professionelle Einheiten mit absoluter Sicherheit
            durchzuführen.
          </p>
        </div>

        <div className="space-y-3" data-id="element-171">
          {modules.map((module, i) => <div key={i} className="bg-white border-2 border-brand-gold/40 p-4 rounded-lg flex gap-3 items-start" data-id="element-172">
              <div className="bg-brand-petrol text-white font-bold px-3.5 py-2 rounded text-sm shrink-0" data-id="element-173">
                MODUL {module.num}
              </div>
              <div data-id="element-174">
                <h3 className="text-lg font-bold text-brand-graphite mb-1" data-id="element-175">
                  ✅ {module.title}
                </h3>
                <p className="text-brand-graphite/70 text-sm leading-relaxed" data-id="element-176">
                  {module.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}